import React from 'react';
import './Chapters.scss';

function Chapter2() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        For its roughly 3,500 people around the world, from Los Angeles to New York to London,
        Company 3 did a quick pivot. It moved its VFX and postproduction processes to the cloud,
        allowing its talent to work together from anywhere “as if they’re in the same location,”
        says Company 3 CTO Robert Keske. Today, the new approaches to postproduction and creative
        collaboration that Company 3 created out of necessity are changing the landscape of that
        field.
      </p>
    </section>
  );
}

export default Chapter2;
